import { render, staticRenderFns } from "./AcceptBtn.vue?vue&type=template&id=98b68d84"
import script from "./AcceptBtn.vue?vue&type=script&lang=ts"
export * from "./AcceptBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports